import React, { Component } from 'react';
import { Infotip, Button, Select } from "../../../../../../../../styleguide";
import { CCPA_NOTICE_URL, CCPA_PRIVACY_MANAGER_URL, PRIVACY_MANAGER_URL } from '../../../../../../../../constants.js';
import { SelectedPrivacyManager } from '../../../../../../contexts';
import { mergePmChoiceOptions } from '../../../../../../../utils';

const { Option } = Select;

export default class LinkPM extends Component {
  static contextType = SelectedPrivacyManager
  state = {
    show: false,
    choice: null
  }
  promiseInfo = {}
  show = async (selectedButtonText) => {
    return new Promise((resolve, reject) => {
      this.promiseInfo = { resolve, reject };
      let newState = { 
        show: true, 
      };

      // find choice option whose button text matches what is selected
      let choice = selectedButtonText && this.props.choiceOptions.find((co) => ( co.data.button_text == selectedButtonText ))

      if(choice) {
        // merge so that we are showing the proper settings
        newState.choice = mergePmChoiceOptions(this.context.selectedPrivacyManager, choice);
      } else {
        // if we don't have one use a default
        this.changeValue('?pmTab=purposes')
      }

      this.setState(newState);
    });
  }
  hide = () => this.setState({ show: false })
  changeValue = (value) => {
    const choice = { type: 12, data: {
      privacy_manager_iframe_url: value,
      button_text: JSON.stringify(Date.now())
    }}

    if(this.context.selectedPrivacyManager.master_privacy_manager_iframe_url) {
      choice.master_privacy_manager_iframe_url = value;
    }

    this.setState({ 
      choice: value 
        ? mergePmChoiceOptions(this.context.selectedPrivacyManager, choice) 
        : null 
    });
  }
  getSelectedValue = () => {
    let selectedValue = '';
    const { choice } = this.state;

    if(choice) {
      const { data, master_privacy_manager_iframe_url } = choice;
      selectedValue = master_privacy_manager_iframe_url || (data && data.privacy_manager_iframe_url);
    }

    return selectedValue;
  }
  selectValue = () => {
    const { resolve, reject } = this.promiseInfo;
    this.hide();
    if (this.state.choice) {
      this.props.updateActions(this.state.choice);
      resolve(this.state.choice);
    } else {
      reject();
    }
  }
  changeDefaultTab = (tab, url) => {
    const newUrl = url.replace('&default_tab=vendors', '');
    if (tab === 'vendors') {
      this.changeValue(`${newUrl}&default_tab=vendors`);
    } else {
      this.changeValue(newUrl);
    }
  }
  // TODO update this to generate ccpa url also
  generateUrl = (id) => {
    if (isNaN(id)) {
      return `${CCPA_PRIVACY_MANAGER_URL}?privacy_manager_id=${id}`
    } else {
      return `${CCPA_NOTICE_URL}/ccpa_pm/index.html?message_id=${id}`
    }
  };
  render() {
    const { show } = this.state;
    const { resolve, reject } = this.promiseInfo;
    const selectedValue = this.getSelectedValue() || '';
    const urlValueNoTabs = selectedValue
      .replace('&pmTab=purposes-li', '')
      .replace('&pmTab=purposes', '')
      .replace('&pmTab=features', '')
      .replace('&pmTab=li', '')
      .replace('&pmTab=vendors-li', '')
      .replace('&pmTab=vendors', '');
   
    const menu = (
      <div style={{ padding: '8px 0', width: '200px' }}>
        <h5>Privacy Manager</h5>
        <Select 
          value={urlValueNoTabs} 
          style={{ width: '100%' }} 
          onChange={this.changeValue}
          disabled={true}     // this is disabled because we rely on the top level setting to change it
          >
          <Option value={null}><i>None</i></Option>
          {this.props.options!=undefined && this.props.options.map((opt) => (
            <Option key={opt.id} value={this.generateUrl(opt.id)}>{opt.description}</Option>
          ))}
        </Select>
        {this.state.choice && (
          <React.Fragment>
            <h5>Default PM Tab</h5>
            <div className="option-inputs">
              <Select
                style={{ width: '100%' }}
                value={selectedValue.includes('&default_tab=vendors') ? 'vendors' : 'purposes'}
                onChange={val => this.changeDefaultTab(val, selectedValue)}
              >
                <Option value="purposes">Purposes</Option>
                <Option value="vendors">Vendors</Option>
              </Select>
            </div>
          </React.Fragment>
        )}
        <div style={{ textAlign: 'right', marginTop: '10px' }}>
          <Button onClick={() => { this.hide(); reject(); }}>Cancel</Button>
          <Button style={{ marginLeft: '5px' }} type="primary" onClick={this.selectValue}>OK</Button>
        </div>
      </div>
    );
    return (
      <button style={{ width: 'auto' }} className="ql-linkPrivacyManager">
        <Infotip open={show} placement="bottom" title="Select Privacy Manager:" content={menu} trigger="click">
          <span>PM</span>
        </Infotip>
      </button>
    );
  }
}
